/**
 * /!\ This file is auto-generated.
 *
 * This is the entry point of your standalone application.
 *
 * There are multiple tags used by the editor to inject code automatically:
 *     - `wle:auto-imports:start` and `wle:auto-imports:end`: The list of import statements
 *     - `wle:auto-register:start` and `wle:auto-register:end`: The list of component to register
 *     - `wle:auto-constants:start` and `wle:auto-constants:end`: The project's constants,
 *        such as the project's name, whether it should use the physx runtime, etc...
 *     - `wle:auto-benchmark:start` and `wle:auto-benchmark:end`: Append the benchmarking code
 */

/* wle:auto-imports:start */
import {FadeToBlack} from '@sorskoot/wonderland-components';
import {Flipbook as Flipbook1} from './flipbook.js';
import {SnapRotate as SnapRotate1} from './snap-rotate.js';
import {Tags as Tags1} from './tags.js';
import {Cursor} from '@wonderlandengine/components';
import {HowlerAudioListener} from '@wonderlandengine/components';
import {MouseLookComponent} from '@wonderlandengine/components';
import {PlayerHeight} from '@wonderlandengine/components';
import {Teleport} from './teleport.js';
import {VrModeActiveSwitch} from '@wonderlandengine/components';
import {WasdControlsComponent} from '@wonderlandengine/components';
import {BoxController} from './box-controller.js';
import {Game} from './game.js';
import {HandleTitleState} from './handle-title-state.js';
import {LevelGenerator} from './level-generator.js';
import {MeshParticles} from './mesh-particles.js';
import {PauseController} from './pause-controller.js';
import {PickTarget} from './pick-target.js';
import {ShowInState} from './show-in-state.js';
import {MainUI} from './ui/main-ui.tsx';
/* wle:auto-imports:end */

import { loadRuntime } from '@wonderlandengine/api';
import * as API from '@wonderlandengine/api'; // Deprecated: Backward compatibility.

/* wle:auto-constants:start */
const Constants = {
    ProjectName: 'StorageSpace13',
    RuntimeBaseName: 'WonderlandRuntime',
    WebXRRequiredFeatures: ['local',],
    WebXROptionalFeatures: ['hit-test',],
};
const RuntimeOptions = {
    physx: false,
    loader: false,
    xrFramebufferScaleFactor: 1,
    xrOfferSession: {
        mode: 'auto',
        features: Constants.WebXRRequiredFeatures,
        optionalFeatures: Constants.WebXROptionalFeatures,
    },
    canvas: 'canvas',
};
/* wle:auto-constants:end */

import { saveGame } from '@wonderlandengine/uber-sdk';
import { LocalStorageSaveGameProvider } from '@wonderlandengine/uber-sdk';

let sdkPromise = null;
if (!WL_EDITOR) {
    const cg = new LocalStorageSaveGameProvider('StorageSpace13');
    saveGame.registerProvider(cg);
}

const engine = await loadRuntime(Constants.RuntimeBaseName, RuntimeOptions);
engine.onLoadingScreenEnd.once(() => {
    const el = document.getElementById('version');
    if (el) setTimeout(() => el.remove(), 2000);
});

/* WebXR setup. */

function requestSession(mode) {
    engine
        .requestXRSession(mode, Constants.WebXRRequiredFeatures, Constants.WebXROptionalFeatures)
        .catch((e) => console.error(e));
}

function setupButtonsXR() {
    /* Setup AR / VR buttons */
    const arButton = document.getElementById('ar-button');
    if (arButton) {
        arButton.dataset.supported = engine.arSupported;
        arButton.addEventListener('click', () => requestSession('immersive-ar'));
    }
    const vrButton = document.getElementById('vr-button');
    if (vrButton) {
        vrButton.dataset.supported = engine.vrSupported;
        vrButton.addEventListener('click', () => requestSession('immersive-vr'));
    }
}

if (document.readyState === 'loading') {
    window.addEventListener('load', setupButtonsXR);
} else {
    setupButtonsXR();
}

/* wle:auto-register:start */
engine.registerComponent(FadeToBlack);
engine.registerComponent(Flipbook1);
engine.registerComponent(SnapRotate1);
engine.registerComponent(Tags1);
engine.registerComponent(Cursor);
engine.registerComponent(HowlerAudioListener);
engine.registerComponent(MouseLookComponent);
engine.registerComponent(PlayerHeight);
engine.registerComponent(Teleport);
engine.registerComponent(VrModeActiveSwitch);
engine.registerComponent(WasdControlsComponent);
engine.registerComponent(BoxController);
engine.registerComponent(Game);
engine.registerComponent(HandleTitleState);
engine.registerComponent(LevelGenerator);
engine.registerComponent(MeshParticles);
engine.registerComponent(PauseController);
engine.registerComponent(PickTarget);
engine.registerComponent(ShowInState);
engine.registerComponent(MainUI);
/* wle:auto-register:end */

try {
    if (sdkPromise) await sdkPromise;
    await engine.loadMainScene(`${Constants.ProjectName}.bin`);
} catch (e) {
    console.error(e);
    window.alert(`Failed to load ${Constants.ProjectName}.bin:`, e);
}
/* wle:auto-benchmark:start */
/* wle:auto-benchmark:end */
